import type MixpanelEvent from '@/integrations/Mixpanel/MixpanelEvent';
import type { MixpanelClientType } from '@/integrations/Mixpanel/types';

export default class MixpanelNoopClient implements MixpanelClientType {
  identify(): void {
    // no-op
  }
  init(): void {
    // no-op
  }
  reset(): void {
    // no-op
  }
  track(_event: MixpanelEvent): void {
    // no-op
  }
}
